<!-- 投手天级统计：巨量  -->
<template>
<div>
	<div id="" :style="{'width':table_scroll_width + 'px',}">
		<div class="page-title"  style="position: sticky;left: 30px;z-index: 5;width: 300px;margin-bottom: 10px;">投手天级统计：巨量</div>
		
		<div :style="{'width':body_width - 60 + 'px',}" style="position: sticky;left: 30px;z-index: 5;">
			<!-- 当天统计数据 -->
			<div style="background-color: #eff1f7;padding: 15px 50px 15px 15px;margin-bottom: 15px;">
				<!-- 刷新 -->
				<div style="display: flex;align-items: center;margin-bottom: 10px;">
					<div style="font-size: 16px;font-weight: 700;margin-right: 20px;">当天统计</div>
					<div @click="RefreshButton('button')" style="display: flex;align-items: center;cursor: pointer;">
						<a-icon :spin="sync_true" style="color: #62A8EA;" type="sync" />
						<div style="color: #62A8EA;margin-left: 10px;">刷新</div>
					</div>
					
				</div>
				<!-- 数据内容 -->
				<div style="display: flex;align-items: center;justify-content: space-between;flex-wrap: wrap;">
					<div>
						<div class="day-data-e" >
							<div class="day-data-a" >{{sameDay[0].cn_plan_num || '-'}}</div>
							<div class="day-data-b">（ 昨日：{{sameDay[1].cn_plan_num || '-'}} ）</div>
						</div>
						<div class="day-data-c">
							有消耗的计划数
						</div>
					</div>
					
					<div>
						<div class="day-data-e" >
							<div class="day-data-a" >{{sameDay[0].cost || '-'}}</div>
							<div class="day-data-b">（ 昨日：{{sameDay[1].cost || '-'}} ）</div>
						</div>
						<div class="day-data-c">
							总消耗
						</div>
					</div>
					
					<div>
						<div class="day-data-e" >
							<div class="day-data-a" >{{sameDay[0].convert || '-'}}</div>
							<div class="day-data-b">（ 昨日：{{sameDay[1].convert || '-'}} ）</div>
						</div>
						<div class="day-data-c">
							总转化数
						</div>
					</div>
					
					<div>
						<div class="day-data-e" >
							<div class="day-data-a" >{{sameDay[0].avg_cost || '-'}}</div>
							<div class="day-data-b">（ 昨日：{{sameDay[1].avg_cost || '-'}} ）</div>
						</div>
						<div class="day-data-c">
							平均转化成本
						</div>
					</div>
					
					<div>
						<div class="day-data-e" >
							<div class="day-data-a" >{{sameDay[0].charge_money || '-'}}</div>
							<div class="day-data-b">（ 昨日：{{sameDay[1].charge_money || '-'}} ）</div>
						</div>
						<div class="day-data-c">
							总分成金额
						</div>
					</div>
					
					<div>
						<div class="day-data-e" >
							<div class="day-data-a" >{{sameDay[0] | dayToFixed}}%</div>
							<div class="day-data-b">（ 昨日：{{sameDay[1] | dayToFixed}}% ）</div>
						</div>
						<div class="day-data-c">
							ROI
						</div>
					</div>
				</div>
				
			</div>
			
			
		</div>
		
	
		<div style="display: flex;align-items: center;position: sticky;left: 30px;z-index: 5;" :style="{'width': body_width - 60 + 'px'}">
			<div v-for="(item,index) in titleTab" :key="index" 
			:class="{'title-tab-box-selected': item.select}" 
			@click="changeTab(item,index)"
			class="title-tab-box">{{item.label}}</div>
		</div>
		
		<div style="display: flex;align-items: center;flex-wrap: wrap;margin: 15px 0;position: sticky;left: 30px;z-index: 5;" :style="{'width': body_width - 60 + 'px'}">
			
			<div class="screen-box" style="margin-bottom: 0;">
				<div class="screen-label">投放日期</div>
				<!-- <a-date-picker @change="onChangeDate" :locale="locale"  :allowClear="false" :value="this.moment(endTime, dateFormat)" /> -->
				<a-range-picker style="width:300px;" @change="onChangeDate" :allowClear="false"
				:locale="locale" 
				:value="[this.moment(startTime, dateFormat),this.moment(endTime, dateFormat)]" />
			</div>
			
			
			
			<div v-show="content_type == 1" class="screen-box" style="margin-bottom: 0;">
				<div class="screen-label">投手</div>
				<a-select
					mode="multiple" 
					style="width: 200px;"
					placeholder="请选择投手"
					@change="handleChangeA"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
					allowClear
					showSearch
				  >
					<a-select-option v-for="(item,index) in filterData.op_id.list" :key="item.key" :value="item.key">
					  {{item.value}}
					</a-select-option>
				</a-select>
			</div>
			
			<a-button @click="searchButton" :loading="search_button_loading" type="primary" icon="search" style="margin-right: 20px;">搜索</a-button>
			
		</div>
	
	</div>
	
	
	<div>
		<!-- 表头 -->
		<div class="table-th" ref="table_th" :style="{'width': table_scroll_width + 'px'}">
			<div   class="table-th-cell-sticky" style="display: flex;align-items: center;">
				<div class="table-th-cell" style="cursor: default;" 
				:style="{'width':rableTitle[0].width + 'px'}" >
					{{rableTitle[0].title}}
				</div>
				<div v-show="content_type == 1" class="table-th-cell" style="cursor: default;"
				:style="{'width':rableTitle[1].width + 'px'}" >
					{{rableTitle[1].title}}
				</div>
				
			</div>
			
			<div  v-for="(item,index) in rableTitle" :key="index" >
			
				<div v-if="index > 1" class="table-th-cell" 
				:style="{'width':item.width + 'px','cursor':item.sort_control?'pointer':'default','justify-content': item.text_right?'flex-end':''}"
				@click="sortClick(index)">
					{{item.title}}
					<div v-if="item.sort_control" style="display: flex;flex-direction: column;width: 12px;margin-left: 5px;">
						<a-icon type="caret-up" :style="{'color': item.sort_status === 2?'#1890ff':'#999'}" style="font-size: 12px;margin-bottom: -4px;" />
						<a-icon type="caret-down" :style="{'color': item.sort_status === 1?'#1890ff':'#999'}" style="font-size: 12px;" />
					</div>
				</div>
			</div>
			<!-- 占位，隔出一个空白区域 -->
			<div id="" style="padding:15px;"></div>
		</div>
		
		
		
		<!-- 表格内容 -->
		<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
			<div  class="table-td-cell-sticky" style="display: flex;align-items: center;">
				
				<div  class="table-td-cell"
				:style="{'width':rableTitle[0].width + 'px'}">
					{{item.date_key}}
				</div>
				<div v-show="content_type == 1" class="table-td-cell"
				:style="{'width':rableTitle[1].width + 'px'}">
					{{item.admin_name}}
				</div>
				
			</div>
			
			<!-- 有消耗的计划数 -->
			<div class="table-td-cell" :style="{'width': rableTitle[2].width + 'px'}">
				{{item.cn_plan_num}}
			</div>
			<!-- 总消耗 -->
			<div class="table-td-cell" :style="{'width': rableTitle[3].width + 'px'}">
				{{item.cost}}
			</div>
			<!-- 平均单计划消耗 -->
			<div class="table-td-cell" :style="{'width': rableTitle[4].width + 'px'}">
				{{item.avg_plan_cost}}
			</div>
			<!-- 总转化数 -->
			<div class="table-td-cell" :style="{'width': rableTitle[5].width + 'px'}">
				{{item.convert}}
			</div>
			<!-- 平均转化成本 -->
			<div class="table-td-cell" :style="{'width': rableTitle[6].width + 'px'}">
				{{item.avg_cost}}
			</div>
			<!-- 平均出价 -->
			<div class="table-td-cell" :style="{'width': rableTitle[7].width + 'px'}">
				{{item.avg_plan_price}}
			</div>
			<!-- 计费比 -->
			<div class="table-td-cell" :style="{'width': rableTitle[8].width + 'px'}">
				{{item.convert_rate}}
			</div>
			<!-- 总分成金额 -->
			<div class="table-td-cell" :style="{'width': rableTitle[9].width + 'px'}">
				{{item.charge_money}}
			</div>
			
			
			<!-- 操作 -->
			<!-- <div class="table-td-cell" :style="{'width': rableTitle[3].width + 'px'}" style="display: flex;flex-wrap: wrap;">
				
				<div @click="editTable(item,1)" style="color: #62a8ea;cursor: pointer;margin-right: 11px;">查看使用详情</div>
				
				<div @click="editTable(item,2)" style="color: #62a8ea;cursor: pointer;">查看小程序详情</div>
			</div> -->
			
			
			
		</div>
		
		
		<div v-show="tableShowData.length === 0" style="text-align: center;margin: 80px 0 50px;" :style="{'width': table_scroll_width + 'px'}">
			<a-icon style="font-size: 70px;color: #999;" type="file-search" />
			
			<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
		</div>
		
		
		<div style="position: fixed;right: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
		<div style="position: fixed;left: 0;bottom:0;z-index: 6;background-color: #fff;height: 90vh;width: 30px;"></div>
		
	</div>
	<!-- 分页 -->
	<div v-show="content_type == 1" :style="{'width': table_scroll_width + 'px',}" style="text-align: center;margin-top: 30px;">
		<a-pagination v-model="r_page" :pageSize="r_limit" :total="table_total" @change="paginationChange" />
	</div>
	<div v-show="content_type == 2" :style="{'width': table_scroll_width + 'px',}" style="text-align: center;margin-top: 30px;">
		<a-pagination v-model="d_page" :pageSize="d_limit" :total="d_table_total" @change="paginationChangeD" />
	</div>
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
import { putDataMenu, JLjhPlanDate,  pitcherDailyList, pitcherDailyHzList } from '@/request/api'
// import JLjhTable from '@/components/JLjhTable.vue'
export default {
	name: 'pitcherDaily_',
	components: {
		
	},
	data() {
		this.dateFormat = 'YYYY-MM-DD'
		return {
			locale,
			moment,
			startTime: '2022-05-01', // 投放日期-开始时间
			endTime: '2022-06-30', // 投放日期-结束时间
			
			titleTab: [
				{label: "投手明细数据", select: true , value: 1 },
				{label: "投手汇总数据", select: false , value: 2 },
			],
			content_type: 1, // 页面内容展现类型
			
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"日期",width:100, sort_status:0, type:"date_key", text_right: false,sort_:90,sort_control: false,show_control: true,}, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"投手",width:100, sort_status:0, type:"admin_name", text_right: false,sort_:89,sort_control: false,show_control: true,},
				{title:"有消耗的计划数",width:130, sort_status:0, type:"cn_plan_num", text_right: false,sort_:89,sort_control: false,show_control: true,},
				{title:"总消耗",width:100, sort_status:0, type:"cost", text_right: false,sort_:36,sort_control: true,show_control: true,},
				{title:"平均单计划消耗",width:150, sort_status:0, type:"avg_plan_cost", text_right: false,sort_:35,sort_control: true,show_control: true,},
				{title:"总转化数",width:100, sort_status:0, type:"convert", text_right: false,sort_:35,sort_control: true,show_control: true,},
				{title:"平均转化成本",width:130, sort_status:0, type:"avg_cost", text_right: false,sort_:35,sort_control: true,show_control: true,},
				{title:"平均出价",width:100, sort_status:0, type:"avg_plan_price", text_right: false,sort_:35,sort_control: true,show_control: true,},
				{title:"计费比",width:100, sort_status:0, type:"convert_rate", text_right: false,sort_:35,sort_control: true,show_control: true,},
				{title:"总分成金额",width:120, sort_status:0, type:"charge_money", text_right: false,sort_:35,sort_control: true,show_control: true,},
			],
			tableShowData: [],
			
			table_scroll_width: 1600,
			body_width: 1600, // 筛选条件大盒子的宽度，用于设置粘性定位
			search_button_loading: false, // 搜索按钮的加载状态
			
			r_page: 1,
			table_total: 0,
			r_limit: 20,
			
			d_page: 1,
			d_table_total: 0,
			d_limit: 20,
			
			r_sort_field: "", // 要排序的字段
			r_sort_type: "", // 排序方式
			
			r_admin_id: [], // 投手
			
			filterData: {
				op_id:{
					list: [{}],
				},
			}, 
			
			sync_true: false, // 刷新的icon是否旋转
			sync_true_control: true, // 刷新的节流控制
			same_day_s: "", // 昨天日期
			same_day_e: "", // 当天日期
			sameDay:[{},{}], // 当天日期的数据
		}
	},
	mounted(){
		let that = this
		
		// that.search_button_loading = true
		
		that.body_width = document.body.clientWidth // 筛选条件大盒子的宽度
		
		let nn = 0
		that.rableTitle.forEach((res,index)=>{
			if(res.show_control){
				nn = nn + res.width
			}
		})
		that.table_scroll_width = nn + 30 + 30
		
		// 获取昨天前日期
		let date1 = new Date(new Date().getTime() - 86400000);
		let same_day1
		if(date1.getDate() < 10){
			same_day1 = "0" + date1.getDate()
		}
		else {
			same_day1 = date1.getDate()
		}
		
		// 获取当前日期
		let date2 = new Date();
		let month2
		if(date2.getMonth() + 1 < 10){
			month2 = '0' + (date2.getMonth() + 1)
		}
		else {
			month2 = date2.getMonth() + 1
		}
		let day2
		if(date2.getDate() < 10){
			day2 = "0" + date2.getDate()
		}
		else {
			day2 = date2.getDate()
		}
		
		// console.log("date2.getDate();",date2.getDate())
		that.endTime = date2.getFullYear() + "-" + month2 + "-" + day2;
		that.startTime = date2.getFullYear() + "-" + month2 + "-" + day2; // 默认只获取当天
		
		that.same_day_s = date2.getFullYear() + month2.toString() + same_day1; // 获取昨天日期
		that.same_day_e = date2.getFullYear() + month2.toString() + day2; // 获取当天日期
		
		putDataMenu().then(res=>{
			console.log("获取搜索条件",res);
			that.filterData = res.data.data.filter
		})
		
		// 获取当天统计数据
		that.RefreshButton()
		
		that.searchButton()
	},
	methods:{
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		// 日期选择
		onChangeDate(date, dateString) {
			console.log(date, dateString);
			this.startTime = dateString[0]
			this.endTime = dateString[1]
		},
		
		changeTab(e,index){
			console.log(e);
			// 如果已经是选中状态就没必要再执行一次了
			if(!this.titleTab[index].select){ 
				this.content_type = e.value
				this.titleTab.forEach(res=>{
					res.select = false
				})
				this.titleTab[index].select = true
				
				this.searchButton()
			}
			
			
		},
		
		// 请选择投手
		handleChangeA(e){
			console.log(e);
			this.r_admin_id = e
		},
		
		// 刷新当天统计数据
		RefreshButton(type){
			let that = this
			this.sync_true = true
			if(this.sync_true_control){ // 节流控制
				that.sync_true_control = false
				// console.log("that.same_day",that.same_day);
				pitcherDailyHzList({
					start_time: that.same_day_s,
					end_time: that.same_day_e,
					// start_time: 20220314,
					// end_time: 20220315,
					type: 1
				}).then(res=>{
					that.sync_true = false
					that.sync_true_control = true
					console.log("刷新当天统计数据",res);
					let data = res.data.data.data
					if(data.length > 0){
						let s_data = []
						let un_data = []
						data.forEach(res=>{
							// 保证当天的数据放在第一项
							if(res.date_key == that.same_day_e){ 
								s_data.push(res)
							}
							else {
								un_data.push(res)
							}
						})
						that.sameDay = s_data.concat(un_data)
					}
					else { // 内容为空
						that.sameDay = [
							{},
							{}
						]
					}
					// console.log("that.sameDay",that.sameDay);
					if(type == 'button'){
						that.$message.success('刷新成功');
					}
					
				})
				.catch(err=>{
					that.sync_true = false
					that.sync_true_control = true
					that.$message.error(`刷新失败`);
				})
			}
			
		},
		
		// 搜索
		searchButton(){
			let that = this
			that.search_button_loading = true
			if(that.content_type == 1){ // 投手明细数据
				let r_data = {
					pageSize: that.r_limit,
					page: that.r_page,
					
					start_time: that.startTime.replace(/-/g, ''),
					end_time: that.endTime.replace(/-/g, ''),
					
					admin_id: that.r_admin_id, // 投手
					
				}
				if(that.r_sort_field){
					r_data.order = that.r_sort_field
					r_data.sort = that.r_sort_type
				}
				pitcherDailyList(r_data).then(res=>{
					console.log("搜索结果",res)
					that.search_button_loading = false
					if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
						that.$message.success('搜索成功');
						that.table_total = res.data.data.total
						that.tableShowData = res.data.data.data
						
					}
					else {
						if(res.data.code === 401){ // 未登录
							localStorage.removeItem("access_token");
							that.$router.replace({name: 'login',params: {type:'not_log'}})
						}
						else {
							that.$message.error(`错误：${res.data.msg}`);
						}
					}
					
					// 在打开了ant design的侧边栏组件之后，每次调搜索请求，body身上都会被加上overflow-x: hidden，就会导致横向滚动条失效，所以要按照下面这么搞
					setTimeout(()=>{
						document.querySelector('body').setAttribute('style', 'overflow-x: visible;')
					},100)
					
				}).catch(err=>{
					console.log(err)
					that.$message.error("搜索失败，可能是网络出现问题");
				})
			}
			else if(that.content_type == 2){
				let r_data = {
					pageSize: that.d_limit,
					page: that.d_page,
					
					start_time: that.startTime.replace(/-/g, ''),
					end_time: that.endTime.replace(/-/g, ''),
					
				}
				if(that.r_sort_field){
					r_data.order = that.r_sort_field
					r_data.sort = that.r_sort_type
				}
				pitcherDailyHzList(r_data).then(res=>{
					console.log("搜索结果",res)
					if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
						that.$message.success('搜索成功');
						that.search_button_loading = false
						that.d_table_total = res.data.data.total
						that.tableShowData = res.data.data.data
						
					}
					else {
						if(res.data.code === 401){ // 未登录
							localStorage.removeItem("access_token");
							that.$router.replace({name: 'login',params: {type:'not_log'}})
						}
						else {
							that.$message.error(`错误：${res.data.msg}`);
						}
					}
					
					// 在打开了ant design的侧边栏组件之后，每次调搜索请求，body身上都会被加上overflow-x: hidden，就会导致横向滚动条失效，所以要按照下面这么搞
					setTimeout(()=>{
						document.querySelector('body').setAttribute('style', 'overflow-x: visible;')
					},100)
					
				}).catch(err=>{
					console.log(err)
					that.$message.error("搜索失败，可能是网络出现问题");
				})
			}
		},
		
		// 点击表格表头，筛选排序
		tableThClick(index,status,type){
			let that = this
			console.log(index,status,type);
			if(status == 0){ // 默认
				that.r_sort_field = ""
				that.r_sort_type = ""
			}
			else if(status == 1){ // desc
				that.r_sort_field = type
				that.r_sort_type = "desc"
			}
			else if(status == 2){ // asc
				that.r_sort_field = type
				that.r_sort_type = "asc"
			}
			
			that.searchButton()
		},
		sortClick(index){ // 点击表头给内容进行排序
			let that = this
			let th_status // 0是默认，1是箭头向下，2是箭头向上
			console.log(that.rableTitle[index].type)
			if(that.rableTitle[index].sort_control){ // 是否有排序功能
				if(index !== this.select_sort_index){
					this.select_sort_index = index
					that.rableTitle.forEach(res=>{
						res.sort_status = 0
					})
					that.rableTitle[index].sort_status = 1
					th_status = 1
				}
				else { // 点击的是同一个表头
					if(that.rableTitle[index].sort_status === 0){
						that.rableTitle[index].sort_status = 1 // 箭头向下
						th_status = 1
					}
					else if(that.rableTitle[index].sort_status === 1){
						that.rableTitle[index].sort_status = 2 // 箭头向上
						th_status = 2
					}
					else if(that.rableTitle[index].sort_status === 2){
						that.rableTitle[index].sort_status = 0
						th_status = 0
					}
				}
				
				
				that.tableThClick(index, th_status, that.rableTitle[index].type)
				// this.$emit('table-th-click', index, th_status, that.rableTitle[index].type)
			}
		},
		
		// 分页
		paginationChange(e){
			let that = this
			this.r_page = e
			that.searchButton()
		},
		paginationChangeD(){
			let that = this
			this.d_page = e
			that.searchButton()
		},
	},
	filters: {
		dayToFixed(e){ // 保留小数点后两位，四舍五入
			// console.log("过滤器",e)
			if(Object.keys(e).length > 0){
				let v = (Number(e.charge_money)/Number(e.cost))*1.06*100
				return v.toFixed(2)
			}
			else {
				return '-'
			}
			
		}
	}
}
</script>

<style scoped>
.day-data-a {
	font-size: 16px;
	font-weight: 800;
}
.day-data-b {
	font-size: 13px;
}
.day-data-c {
	font-size: 13px;
	margin-top: 5px;
}
.day-data-e {
	display: flex;
	align-items: flex-end;
}


.title-tab-box {
	color: #313a46;
	padding: 8px 20px;
	border: 1px solid #ccc;
	cursor: pointer;
}

.title-tab-box-selected {
	color: #62a8ea;
	border: 1px solid #62a8ea;
}
	
	
/* 表格非公共内容 */
.table-th-cell:hover {
	background-color: #eee;
}
.table-th-cell:hover .table-th-cell-sticky{
	background-color: #eee;
}



</style>